import { formatCpfNumber } from '@/utils/masks/cpf'
import { DependenteData } from '../types/pt-br'
import { Patient } from '../types/en-us'

class GetDependentData {
  toDomain(data: DependenteData[]): Patient[] {
    return data?.map(dependent => ({
      name: dependent?.nome || '',
      cpf: formatCpfNumber(dependent?.cpf) || '',
      birthdate:
        dependent?.dataNascimento?.split('-')?.reverse()?.join('/') || '',
      email: dependent?.email || '',
      cellphone: dependent?.telefoneCelular || '',
      active: dependent?.flagAtivo,
      id: dependent?.idUsuario || null,
      idDependent: dependent?.idDependente || null,
      token: dependent?.token || null,
      refreshToken: dependent?.refreshToken || null,
      flagAccessedBefore: dependent?.flagAcessou || false,
      ...(dependent?.idClinica && { clinic: { id: dependent?.idClinica } }),
    }))
  }
}

export default new GetDependentData()
